<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import { clickOutside } from '../../utilities/clickOutside';

    export let isOpen: boolean = false;
    export let statusMessage: string = '';
    export let errorMessage: string = '';
    export let rowErrors: Array<{ row: number; message: string }> = [];
    export let onClick: () => void = () => {};

    $: hasErrors = !!errorMessage || rowErrors.length > 0;

    function clickOk() {
        closeModal();
        onClick();
    }
</script>

{#if isOpen}
    <div role="dialog" class="modal" use:clickOutside on:click_outside={clickOk}>
        <div class="contents" class:has-errors={hasErrors}>
            {#if statusMessage}
                <div class="status" class:error={hasErrors} class:success={!hasErrors}>
                    {statusMessage}
                </div>
            {/if}
            {#if errorMessage}
                <div class="error-message">
                    {errorMessage}
                </div>
            {/if}
            {#if rowErrors.length > 0}
                <div class="row-errors">
                    <strong>{$_('errors_label')}</strong>
                    <ul>
                        {#each rowErrors as err}
                            <li>{$_('row_error', { values: { row: err.row, message: err.message } })}</li>
                        {/each}
                    </ul>
                </div>
            {/if}
            <div class="actions">
                <ButtonMain text={$_('OK')} on:click={clickOk} />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;
        pointer-events: none;
    }

    .contents {
        min-width: 390px;
        max-width: 490px;
        max-height: 80vh;
        overflow-y: auto;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
        border: 3px solid var(--automapa-blue);
        box-shadow:
            0 0 0 10px #1c5dc722,
            0 4px 8px rgba(0, 0, 0, 0.2);
        row-gap: 8px;
    }

    .contents.has-errors {
        border-color: #d45659;
        box-shadow:
            0 0 0 10px #d93b4d44,
            0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .status.success {
        color: #2e7d32;
        text-align: center;
    }

    .status.error {
        color: #d32f2f;
    }

    .error-message {
        color: #d32f2f;
    }

    .row-errors {
        font-size: 12px;
        margin-top: 4px;
    }

    .row-errors ul {
        margin: 4px 0 0 16px;
        padding: 0;
    }

    .row-errors li {
        color: #d32f2f;
    }

    .actions {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
</style>
